<template>
  <div
    class="w-full flex items-center justify-between font-semibold text-sm text-left text-gray-brand-600 bg-gray-brand-100 py-1 px-2 rounded-lg"
    :class="[count > 0 ? 'bg-gray-brand-200' : '', !canAddMore && count == 0 ? 'opacity-80' : '']"
  >
    <div>
      {{ variantOption.name }}
      <span v-if="hasPrice && showPrice && showPlusSign">(+{{ variantOption.price_formatted.format }})</span>
      <span v-else-if="hasPrice && showPrice">({{ variantOption.price_formatted.format }})</span>
      <div v-if="variantOption.description" class="font-normal" data-testid="variant-option-description">
        {{ variantOption.description }}
      </div>
    </div>
    <div class="flex flex-shrink-0">
      <button
        class="inline-block w-10 h-8 p-2 px-3 rounded-l-lg items-center focus:outline-none"
        :class="[
          count > 0
            ? 'bg-transparent text-gray-brand-700 opacity-100'
            : 'bg-transparent text-gray-brand-500 opacity-50 cursor-not-allowed'
        ]"
        :disabled="count == 0"
        @click="decreaseCount()"
      >
        <svg
          class="w-full fill-current"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M20 12H4"></path>
        </svg>
      </button>
      <div class="flex rounded-md group">
        <input
          type="text"
          inputmode="numeric"
          placeholder="0"
          class="peer w-8 h-8 text-center font-inter font-semibold focus:outline-none"
          :value="countForValue"
          :class="[
            count > 0 ? 'bg-transparent text-gray-brand-700' : 'bg-transparent text-gray-brand-500 rounded-l-lg'
          ]"
          @change="set(parseInt($event.target.value, 10) || 0)"
        />
      </div>
      <button
        class="inline-block w-10 h-8 p-2 px-3 rounded-r-lg items-center focus:outline-none"
        :class="[
          count > 0 ? 'bg-transparent text-gray-brand-700' : 'bg-transparent text-gray-brand-500',
          !canAddMore ? 'opacity-50 cursor-not-allowed' : 'opacity-100'
        ]"
        :disabled="!canAddMore"
        @click="increaseCount()"
      >
        <svg
          class="w-full fill-current"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'V2ProductVariantOptionCustomQuantity',

  props: {
    variantOption: {
      type: Object,
      required: true
    },
    variant: {
      type: Object,
      required: true
    },
    submittableCartItem: {
      type: Object,
      default: null
    },
    showPrice: {
      type: Boolean,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  },

  emits: ['quantitySet', 'unselected'],

  computed: {
    cartItemVariantOptionAttributes() {
      if (!this.submittableCartItem?.cart_item_variant_options_attributes) return null
      return this.submittableCartItem.cart_item_variant_options_attributes.find(
        (x) => x.variant_option_id == this.variantOption.id
      )
    },
    count() {
      return this.cartItemVariantOptionAttributes?.quantity || 0
    },
    countForValue() {
      return this.count === 0 ? null : this.count
    },
    totalQuantityForVariant() {
      if (!this.submittableCartItem?.cart_item_variant_options_attributes) return 0
      return this.submittableCartItem.cart_item_variant_options_attributes
        .filter((x) => x.variant_id == this.variant.id)
        .reduce((sum, x) => sum + (x.quantity || 0), 0)
    },
    optionInventoryRemaining() {
      const remaining = this.variantOption.inventory_remaining
      if (remaining === null || remaining === undefined) return Infinity
      return remaining
    },
    canAddMore() {
      const max = this.variant.max || 100
      return this.totalQuantityForVariant < max && this.count < this.optionInventoryRemaining
    },
    hasPrice() {
      return this.variantOption.price_cents > 0
    },
    showPlusSign() {
      return this.product.price_cents > 0
    }
  },

  methods: {
    decreaseCount() {
      if (this.count === 0) return
      this.set(this.count - 1)
    },
    increaseCount() {
      this.set(this.count + 1)
    },
    set(quantity) {
      if (quantity > 0) {
        this.$emit('quantitySet', this.variantOption, quantity)
      } else {
        this.$emit('unselected', this.variantOption)
      }
    }
  }
}
</script>
